import React from "react";
import {
  Table,
  TableContainer,
  TableContainerProps,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { CopyText } from "../Utilities/CopyText";

interface TableListViewDictionaryProps<T> {
  dictionary: { [key: string]: T } | null;
  emptyMessage?: string;
}

export function TableListViewDictionary<T>({
  dictionary,
  emptyMessage,
  ...props
}: TableListViewDictionaryProps<T> & TableContainerProps) {
  const emptyList = !dictionary || !Object.keys(dictionary).length;

  const formatValue = (value: any) => {
    if (value == null) return <Text>-</Text>;

    switch (typeof value) {
      case "object":
        return <TableListViewDictionary dictionary={value as any} />;
      case "boolean":
        return (
          <Text>{value == true ? "Yes" : value == false ? "No" : "-"}</Text>
        );

      default:
        return (
          <CopyText hover adjustMargin>
            {value}
          </CopyText>
        );
    }
  };

  if (emptyList) {
    return <Text fontStyle="italic">{emptyMessage ?? "List is empty"}</Text>;
  }

  return (
    <TableContainer alignSelf="start" width="100%" overflowX="auto" {...props}>
      <Table size="sm">
        <Thead>
          <Tr>
            <Th>Field</Th>
            <Th>Value</Th>
          </Tr>
        </Thead>
        <Tbody>
          {Object.entries(dictionary).map(([key, value], idx) => (
            <Tr key={idx}>
              <Td w="30%">{key}</Td>
              <Td>{formatValue(value)}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
